import React from "react";
import { AlertTriangle, X, RefreshCw } from "lucide-react";

interface ErrorBannerProps {
  message: string;
  onDismiss?: () => void;
  onRetry?: () => void;
}

export function ErrorBanner({ message, onDismiss, onRetry }: ErrorBannerProps) {
  return (
    <div className="mx-3 mt-2 bg-ca-punch/8 border border-ca-punch/15 rounded-xl px-3 py-2.5 flex items-start gap-2.5 text-[12px] shrink-0">
      <AlertTriangle size={14} className="text-ca-punch shrink-0 mt-0.5" />
      <span className="flex-1 text-text-primary leading-snug">{message}</span>
      <div className="flex items-center gap-1 shrink-0">
        {onRetry && (
          <button
            onClick={onRetry}
            className="flex items-center gap-1 text-ca-punch font-medium hover:underline text-[11px]"
          >
            <RefreshCw size={11} />
            Retry
          </button>
        )}
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="w-5 h-5 rounded flex items-center justify-center text-text-muted hover:text-text-primary transition-colors"
          >
            <X size={13} />
          </button>
        )}
      </div>
    </div>
  );
}
